import { makeNumeric } from "./makeDataColumnInteger";

export const makeColumnDataNegative = (worksheet, object) => {
  const changes = [];

  for (let i = 1; i <= worksheet.rowCount; i++) {
    const cellContent = worksheet.getCell(`${object.inColChr}${i}`).value;

    if (cellContent) {
      const replace = -Math.abs(makeNumeric(cellContent));

      // Track changes only if value actually changed
      if (replace !== cellContent) {
        changes.push({
          rowIndex: i,
          originalValue: cellContent,
          convertedValue: replace,
        });
      }

      worksheet.getCell(`${object.inColChr}${i}`).value =
        replace ?? cellContent;
    }
  }

  return changes;
};
